<script setup lang="ts">
import { computed } from 'vue';
import { get, find } from 'lodash-es';
import type { IColumnDefinition, RowData, ISelectColumn } from '../types';

const props = defineProps<{
  value: any;
  row: RowData;
  column: IColumnDefinition;
}>();

const displayValue = computed(() => {
  const val = props.value;
  if (val === null || val === undefined) {
    return '';
  }

  const col = props.column as ISelectColumn;
  const valField = col.valueField || 'id';
  const txtField = col.textField || 'text';

  if (col.bindObject && typeof val === 'object') {
    return get(val, txtField);
  }

  const options = col.options;
  if (!options || !Array.isArray(options)) {
    return val;
  }

  const foundOption = find(options, (opt: any) => {
    if (typeof opt === 'string') {
      return opt === val;
    }
    return get(opt, valField) == val;
  });

  if (foundOption) {
    return typeof foundOption === 'string'
      ? foundOption
      : get(foundOption, txtField);
  }

  return val;
});
</script>

<template>
  <span class="itp-select-formatter text-wrap">
    {{ displayValue }}
  </span>
</template>
